import React from 'react';
import { Loader } from 'lucide-react';
import { ButtonProps } from './types';

export const Button: React.FC<ButtonProps> = ({
	children,
	className = '',
	isLoading = false,
	variant = 'primary',
	size = 'md',
	fullWidth = true,
	disabled,
	...props
}) => {
	const baseStyles =
		'inline-flex items-center justify-center rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';

	const variants = {
		primary:
			'bg-[#4C7CFF] hover:bg-[#4c66ff] text-white focus:ring-[#4C7CFF]',
		secondary:
			'bg-gray-100 hover:bg-gray-200 text-gray-900 focus:ring-gray-200',
		outline:
			'border border-gray-300 hover:bg-gray-200 text-gray-700 focus:ring-gray-200',
		link: 'text-[#4C7CFF] focus:outline-none focus:border-none focus:ring-transparent',
		success:
			'bg-green-500 hover:bg-green-600 text-white focus:ring-green-500'
	};

	const sizes = {
		sm: 'px-3 py-1.5 text-sm',
		md: 'px-4 py-3 text-base',
		lg: 'px-6 py-3 text-lg'
	};

	return (
		<button
			className={` ${fullWidth ? 'w-full' : ''} ${baseStyles} ${variants[variant]} ${sizes[size]} ${isLoading || disabled ? 'cursor-not-allowed opacity-50' : ''} ${className} `}
			disabled={isLoading || disabled}
			{...props}
		>
			{isLoading && <Loader className='mr-2 h-4 w-4 animate-spin' />}
			{children}
		</button>
	);
};
